export default __webpack_public_path__ + "static/media/dropdownArrow.daa61657.svg";